import type {
  LandingClosingContent,
  LandingHeroContent,
  LandingMetaContent,
} from "../types";

// Register note, set here and held for the rest of the German set: the English
// hero addresses the reader with pronoun-less imperatives ("Pass once, trade
// live"). German keeps that by using the infinitive construction rather than
// picking "Sie" or "du" — the source made no such choice, and inventing one
// would change the voice of the brand inside a translation task.
export const landingMeta: LandingMetaContent = {
  // [de-review] The home page's SERP and social presentation — the most-linked
  // surface on the site. Inside the 60/160 caps.
  title: "Flex Fund — MT5 Prop Firm | Wöchentliche Auszahlungen",
  description:
    "Flex Fund ist eine MetaTrader-5-Prop-Firm: finanziertes Kapital, Raw Spreads, bis zu 90 % Profit-Split, wöchentliche Auszahlungen. Einmal bestehen, live traden.",
};

export const landingHero: LandingHeroContent = {
  headline: {
    line1: "Finanziertes Kapital.",
    line2: "Raw Spreads.",
    line3Highlight: "Wöchentliche Auszahlungen.",
  },
  // [de-review] Names the offer: funded capital, raw spreads, profit split.
  lede: "Flex Fund gibt ambitionierten Tradern finanziertes Kapital, Raw Spreads und branchenführende Profit-Splits. Einmal bestehen, live traden, wöchentlich auszahlen.",
  // Distinct from the nav label ("So funktioniert's") for the same reason the
  // English button says "See how it works" rather than "How It Works".
  ctaSecondary: "Ablauf ansehen",
  ticket: {
    sampleEvaluation: "BEISPIEL-EVALUATION",
    twoStep: "2-PHASEN",
    from: "AB",
    // Uppercase German replaces "ß" with "SS" — "KONTOGRÖSSE", never "KONTOGRÖßE".
    accountSize: "KONTOGRÖSSE",
    rows: {
      // [de-review] These six label the commercial terms of the evaluation.
      oneTimeFee: "EINMALIGE GEBÜHR",
      profitTarget: "GEWINNZIEL",
      profitSplit: "PROFIT-SPLIT",
      leverage: "HEBEL",
      timeLimit: "ZEITLIMIT",
      payoutCycle: "AUSZAHLUNGSZYKLUS",
    },
    values: {
      // "KEINS" agrees with "das Zeitlimit"; "KEINE" would be a gender error.
      noTimeLimit: "KEINS",
      weekly: "WÖCHENTLICH",
    },
    configureYourOwn: "Eigenes konfigurieren",
  },
  stats: {
    fastPayouts: { display: "SCHNELLE AUSZAHLUNGEN", label: "Wöchentlich ausgezahlt" },
    // [de-review] A commercial claim about the profit split.
    profitSplitBase: { label: "Basis-Profit-Split" },
    payoutCycleDays: { label: "Tage Auszahlungszyklus" },
  },
};

export const landingClosing: LandingClosingContent = {
  headlineLead: "Bereit, ",
  headlineHighlight: "finanziert zu werden?",
  // [de-review] Carries the headline commercial claims: the 90% profit split,
  // weekly payouts and the evaluation promise. German writes a space before the
  // percent sign ("90 %"), which is the DIN convention, not a typo.
  body: "Die Evaluation einmal bestehen, dann echtes Kapital traden — bis zu 90 % Profit-Split, wöchentliche Auszahlungen und institutionelle MetaTrader-5-Ausführung.",
  ctaSecondary: "So funktioniert's",
};
